export default Object.freeze({
  Available: 1,
  Unavailable: 2,
});
